module.exports = __webpack_public_path__ + "media/images/category_icons/small_talk-9c412e7b68d9fd2dba543e9e3ea55ccc.svg";